/* eslint-disable quotes, quote-props, @typescript-eslint/quotes */
/* Auto-generated from inventory sequence definitions. */

export const SEQUENCE_CALCULATION_FORMULAS: Readonly<Record<string, Readonly<Record<string, string>>>> = {
	"BACKGROUND_COUNT_BARIUM": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"BACKGROUND_COUNT_CAESIUM": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"BACKGROUND_COUNT_COBALT": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"BACKGROUND_COUNT_INTEGRAL": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"BACKGROUND_COUNT_IODINE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"BACKGROUND_COUNT_TECHNETIUM": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"BACKGROUND_ZERO_EFFECT": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"BACKGROUND_ZERO_EFFECT_FREE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "sequence.upperThreshold",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"BACKGROUND_ZERO_EFFECT_V2": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"BOREHOLE_FACTOR": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.1 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.05 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.95 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.9 ), sequence.referenceValue )",
		"deviation": "Difference( value, expectedValue )"
	},
	"BOREHOLE_FACTOR_PAYLOAD": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.1 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.05 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.95 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.9 ), sequence.referenceValue )",
		"value": "Quotient( Mean( activityProbeOne, activityProbeTwo, activityProbeThree ), Difference( activitySyringeFull, activitySyringeEmpty ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"CHECK": {
		"recordedAt": "Fallback( recordedAt, dateTime )"
	},
	"CTDI": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.8 ), sequence.referenceValue )",
		"deviation": "Difference( value, expectedValue )"
	},
	"CTDI_CUSTOM": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "sequence.upperThreshold",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "sequence.lowerThreshold",
		"deviation": "Difference( value, expectedValue )"
	},
	"DOSE_INDICATOR": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "sequence.upperThreshold",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "sequence.lowerThreshold",
		"deviation": "Difference( value, expectedValue )"
	},
	"DOSE_SURFACE_PRODUCT_ABSOLUTE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "sequence.upperThreshold",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "sequence.lowerThreshold",
		"deviation": "Difference( value, expectedValue )"
	},
	"DOSE_SURFACE_PRODUCT_RELATIVE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "sequence.upperThreshold",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "sequence.lowerThreshold",
		"deviation": "Difference( value, expectedValue )"
	},
	"EDGE_DEVIATION": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "sequence.upperThreshold",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"EXTRINSIC_HOMOGENEITY": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Literal( 5 )",
		"upperReactionValue": "Minimum( Literal( 3 ), Product( Literal( 1.5 ), sequence.referenceValue ) )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"EXTRINSIC_HOMOGENEITY_V2": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Literal( 5 )",
		"upperReactionValue": "Minimum( Literal( 3 ), Product( Literal( 1.5 ), sequence.referenceValue ) )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"EXTRINSIC_HOMOGENEITY_V3": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Literal( 5 )",
		"upperReactionValue": "Minimum( Literal( 4 ), Product( Literal( 1.5 ), sequence.referenceValue ) )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"EXTRINSIC_HOMOGENEITY_V4": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Literal( 5 )",
		"upperReactionValue": "Literal( 4 )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"FREE_TEXT": {
		"recordedAt": "Fallback( recordedAt, dateTime )"
	},
	"GENERIC_CUSTOM": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperThreshold": "sequence.upperThreshold",
		"expectedValue": "sequence.referenceValue",
		"lowerThreshold": "sequence.lowerThreshold",
		"deviation": "Difference( value, expectedValue )"
	},
	"GEOMETRY_FACTOR_DETERMINATION": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.15 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.075 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.925 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.85 ), sequence.referenceValue )",
		"deviation": "Difference( value, expectedValue )"
	},
	"HELIUM_LEVEL": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "sequence.lowerThreshold",
		"deviation": "Difference( value, expectedValue )"
	},
	"HOMOGENEITY": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Literal( 8 )",
		"upperReactionValue": "Literal( 6 )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"HOMOGENEITY_WITHOUT_CORRECTION_MATRIX": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.1 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.08 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"INTRINSIC_HOMOGENEITY": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Literal( 5 )",
		"upperReactionValue": "Minimum( Literal( 3 ), Product( Literal( 1.5 ), sequence.referenceValue ) )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"INTRINSIC_HOMOGENEITY_V2": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Literal( 5 )",
		"upperReactionValue": "Minimum( Literal( 4 ), Product( Literal( 1.5 ), sequence.referenceValue ) )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"INTRINSIC_HOMOGENEITY_V3": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Literal( 5 )",
		"upperReactionValue": "Literal( 4 )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"LINE_RESOLUTION": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "sequence.lowerThreshold",
		"deviation": "Difference( value, expectedValue )"
	},
	"LINEARITY_FLUORINE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, recordedAt ), recordedAt )",
		"adjustedReferenceValue": "Fallback( memory.initialValue, adjustedValue )",
		"adjustedUpperToleranceValue": "Product( Literal( 1.05 ), adjustedReferenceValue )",
		"adjustedUpperReactionValue": "Product( Literal( 1.03 ), adjustedReferenceValue )",
		"adjustedExpectedValue": "adjustedReferenceValue",
		"adjustedLowerReactionValue": "Product( Literal( 0.97 ), adjustedReferenceValue )",
		"adjustedLowerToleranceValue": "Product( Literal( 0.95 ), adjustedReferenceValue )",
		"adjustedValue": "Undecay( value, recordedHours, F_9 )",
		"adjustedDeviation": "Difference( adjustedValue, adjustedExpectedValue )",
		"upperToleranceValue": "Decay( adjustedUpperToleranceValue, recordedHours, F_9 )",
		"upperReactionValue": "Decay( adjustedUpperReactionValue, recordedHours, F_9 )",
		"expectedValue": "Decay( adjustedExpectedValue, recordedHours, F_9 )",
		"lowerReactionValue": "Decay( adjustedLowerReactionValue, recordedHours, F_9 )",
		"lowerToleranceValue": "Decay( adjustedLowerToleranceValue, recordedHours, F_9 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"LINEARITY_TECHNETIUM": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, recordedAt ), recordedAt )",
		"adjustedReferenceValue": "Fallback( memory.initialValue, adjustedValue )",
		"adjustedUpperToleranceValue": "Product( Literal( 1.05 ), adjustedReferenceValue )",
		"adjustedUpperReactionValue": "Product( Literal( 1.03 ), adjustedReferenceValue )",
		"adjustedExpectedValue": "adjustedReferenceValue",
		"adjustedLowerReactionValue": "Product( Literal( 0.97 ), adjustedReferenceValue )",
		"adjustedLowerToleranceValue": "Product( Literal( 0.95 ), adjustedReferenceValue )",
		"adjustedValue": "Undecay( value, recordedHours, TC_99_M )",
		"adjustedDeviation": "Difference( adjustedValue, adjustedExpectedValue )",
		"upperToleranceValue": "Decay( adjustedUpperToleranceValue, recordedHours, TC_99_M )",
		"upperReactionValue": "Decay( adjustedUpperReactionValue, recordedHours, TC_99_M )",
		"expectedValue": "Decay( adjustedExpectedValue, recordedHours, TC_99_M )",
		"lowerReactionValue": "Decay( adjustedLowerReactionValue, recordedHours, TC_99_M )",
		"lowerToleranceValue": "Decay( adjustedLowerToleranceValue, recordedHours, TC_99_M )",
		"deviation": "Difference( value, expectedValue )"
	},
	"LINEARITY_V2_FLUORINE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, recordedAt ), recordedAt )",
		"adjustedReferenceValue": "Fallback( memory.meanAdjustedValue, adjustedValue )",
		"adjustedUpperToleranceValue": "Product( Literal( 1.05 ), adjustedReferenceValue )",
		"adjustedUpperReactionValue": "Product( Literal( 1.03 ), adjustedReferenceValue )",
		"adjustedExpectedValue": "adjustedReferenceValue",
		"adjustedLowerReactionValue": "Product( Literal( 0.97 ), adjustedReferenceValue )",
		"adjustedLowerToleranceValue": "Product( Literal( 0.95 ), adjustedReferenceValue )",
		"adjustedValue": "Undecay( value, recordedHours, F_9 )",
		"adjustedDeviation": "Difference( adjustedValue, adjustedExpectedValue )",
		"upperToleranceValue": "Decay( adjustedUpperToleranceValue, recordedHours, F_9 )",
		"upperReactionValue": "Decay( adjustedUpperReactionValue, recordedHours, F_9 )",
		"expectedValue": "Decay( adjustedExpectedValue, recordedHours, F_9 )",
		"lowerReactionValue": "Decay( adjustedLowerReactionValue, recordedHours, F_9 )",
		"lowerToleranceValue": "Decay( adjustedLowerToleranceValue, recordedHours, F_9 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"LINEARITY_V2_TECHNETIUM": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, recordedAt ), recordedAt )",
		"adjustedReferenceValue": "Fallback( memory.meanAdjustedValue, adjustedValue )",
		"adjustedUpperToleranceValue": "Product( Literal( 1.05 ), adjustedReferenceValue )",
		"adjustedUpperReactionValue": "Product( Literal( 1.03 ), adjustedReferenceValue )",
		"adjustedExpectedValue": "adjustedReferenceValue",
		"adjustedLowerReactionValue": "Product( Literal( 0.97 ), adjustedReferenceValue )",
		"adjustedLowerToleranceValue": "Product( Literal( 0.95 ), adjustedReferenceValue )",
		"adjustedValue": "Undecay( value, recordedHours, TC_99_M )",
		"adjustedDeviation": "Difference( adjustedValue, adjustedExpectedValue )",
		"upperToleranceValue": "Decay( adjustedUpperToleranceValue, recordedHours, TC_99_M )",
		"upperReactionValue": "Decay( adjustedUpperReactionValue, recordedHours, TC_99_M )",
		"expectedValue": "Decay( adjustedExpectedValue, recordedHours, TC_99_M )",
		"lowerReactionValue": "Decay( adjustedLowerReactionValue, recordedHours, TC_99_M )",
		"lowerToleranceValue": "Decay( adjustedLowerToleranceValue, recordedHours, TC_99_M )",
		"deviation": "Difference( value, expectedValue )"
	},
	"LOW_CONTRAST_OBJECTS": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "sequence.lowerThreshold",
		"deviation": "Difference( value, expectedValue )"
	},
	"MOLYBDENUM_BREAKTHROUGH_MOLYBDENUM": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Literal( 0.1 )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"MOLYBDENUM_BREAKTHROUGH_PAYLOAD": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Literal( 0.04 )",
		"expectedValue": "sequence.referenceValue",
		"value": "Percent( activityMolybdenum, activityTechnetium )",
		"deviation": "Difference( value, expectedValue )"
	},
	"MOLYBDENUM_BREAKTHROUGH_TECHNETIUM": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Literal( 0.04 )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"NUCLIDE_POSITION_RESPONSIVENESS": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"recordedHours": "Hours( sequence.referenceDate, recordedAt )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), sequence.referenceValue ), recordedHours, CS_137 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), sequence.referenceValue ), recordedHours, CS_137 )",
		"expectedValue": "Decay( sequence.referenceValue, recordedHours, CS_137 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), sequence.referenceValue ), recordedHours, CS_137 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), sequence.referenceValue ), recordedHours, CS_137 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"NUCLIDE_POSITION_ZERO_EFFECT": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 2 ), Maximum( Literal( 0.15 ), sequence.referenceValue ) )",
		"upperReactionValue": "Product( Literal( 1.5 ), Maximum( Literal( 0.15 ), sequence.referenceValue ) )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"NUCLIDE_POSITION_ZERO_EFFECT_802": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 2 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( value, expectedValue )"
	},
	"OBJECTIVE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperThreshold": "sequence.upperThreshold",
		"expectedValue": "Literal( 0 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_PHILIPS_GEMINI_FWHM_AVERAGE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 19 )",
		"expectedValue": "Literal( 9.5 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_PHILIPS_GEMINI_LARGEST_MAX_MIN_DELTA_TILT": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 2 )",
		"expectedValue": "Literal( 1 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_PHILIPS_GEMINI_MAX_BASELINE_DIFFERENCE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 7 )",
		"expectedValue": "Literal( 3.5 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_PHILIPS_GEMINI_SUV_VALIDATION_AND_HOMOGENITY": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 1.1 )",
		"expectedValue": "Literal( 1 )",
		"lowerReactionValue": "Literal( 0.9 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_AXIAL_ABERRANCE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 5 )",
		"expectedValue": "Literal( 2.5 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_ENERGY_TEST_AVERAGE_CENTROID": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 140 )",
		"expectedValue": "Literal( 106 )",
		"lowerReactionValue": "Literal( 68 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_ENERGY_TEST_AVERAGE_ENERGY_RESOLUTION": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 13 )",
		"expectedValue": "Literal( 7 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_INTEGRAL_HOMOGENITY": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 2.5 )",
		"expectedValue": "Literal( 1.25 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_MID_SUV_OF_HOMOGENITY": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 1.05 )",
		"expectedValue": "Literal( 1 )",
		"lowerReactionValue": "Literal( 0.95 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_MID_SUV_OF_HOMOGENITY_BRAIN": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 1.1 )",
		"expectedValue": "Literal( 1 )",
		"lowerReactionValue": "Literal( 0.9 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_TIMING_RESOLUTION": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 450 )",
		"expectedValue": "Literal( 225 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_UNIFORMITY_TEST_BAD_PIXELS": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 160 )",
		"expectedValue": "Literal( 80 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_SIEMENS_GENERIC_BLOCK_EFFICIENCY": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 120 )",
		"expectedValue": "Literal( 100 )",
		"lowerReactionValue": "Literal( 80 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_SIEMENS_GENERIC_BLOCK_NOISE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 10 )",
		"expectedValue": "Literal( 5 )",
		"lowerReactionValue": "Literal( 0 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_SIEMENS_GENERIC_MEASURED_RANDOMS": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Literal( 115 )",
		"expectedValue": "Literal( 100 )",
		"lowerReactionValue": "Literal( 85 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_SIEMENS_GENERIC_SCANNER_EFFICIENCY": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Product( Literal( 1.3 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.7 ), sequence.referenceValue )",
		"deviation": "Difference( value, expectedValue )"
	},
	"PET_CT_SIEMENS_GENERIC_SCATTER_RATIO": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperReactionValue": "Product( Literal( 1.3 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.7 ), sequence.referenceValue )",
		"deviation": "Difference( value, expectedValue )"
	},
	"POWER_WINDOW": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.04 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.02 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.98 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.96 ), sequence.referenceValue )",
		"deviation": "Difference( value, expectedValue )"
	},
	"POWER_WINDOW_PERCENTAGE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Literal( 4 )",
		"upperReactionValue": "Literal( 2 )",
		"expectedValue": "Literal( 0 )",
		"lowerReactionValue": "Literal( -2 )",
		"lowerToleranceValue": "Literal( -4 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"POWER_WINDOW_PERCENTAGE_V2": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Sum( Literal( 4 ), sequence.referenceValue )",
		"upperReactionValue": "Sum( Literal( 2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Sum( Literal( -2 ), sequence.referenceValue )",
		"lowerToleranceValue": "Sum( Literal( -4 ), sequence.referenceValue )",
		"deviation": "Difference( value, expectedValue )"
	},
	"POWER_WINDOW_SETTING": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.05 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.025 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.975 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.95 ), sequence.referenceValue )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RESPONSIVENESS": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"recordedHours": "Hours( sequence.referenceDate, recordedAt )",
		"upperToleranceValue": "Decay( Product( Literal( 1.15 ), sequence.referenceValue ), recordedHours, CO_57 )",
		"upperReactionValue": "Decay( Product( Literal( 1.1 ), sequence.referenceValue ), recordedHours, CO_57 )",
		"expectedValue": "Decay( sequence.referenceValue, recordedHours, CO_57 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.9 ), sequence.referenceValue ), recordedHours, CO_57 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.85 ), sequence.referenceValue ), recordedHours, CO_57 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RESPONSIVENESS_CS_137": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"recordedHours": "Hours( sequence.referenceDate, recordedAt )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), sequence.referenceValue ), recordedHours, CS_137 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), sequence.referenceValue ), recordedHours, CS_137 )",
		"expectedValue": "Decay( sequence.referenceValue, recordedHours, CS_137 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), sequence.referenceValue ), recordedHours, CS_137 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), sequence.referenceValue ), recordedHours, CS_137 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RESPONSIVENESS_CS_137_V2": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"recordedHours": "Hours( sequence.referenceDate, recordedAt )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), sequence.referenceValue ), recordedHours, CS_137 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), sequence.referenceValue ), recordedHours, CS_137 )",
		"expectedValue": "Decay( sequence.referenceValue, recordedHours, CS_137 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), sequence.referenceValue ), recordedHours, CS_137 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), sequence.referenceValue ), recordedHours, CS_137 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CARTRIDGE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "sequence.lowerThreshold",
		"value": "Percent( activityElution, Sum( activityElution, activityCartridge ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_NANOCIS_SINGLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Percent( activityStart, Sum( activityStart, activityFront ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_NEUROLITE_SINGLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 90 )",
		"value": "Percent( activityStart, Sum( activityStart, activityFront ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_PULMOCIS_FILTER": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 90 )",
		"value": "Percent( activityElution, Sum( activityElution, activityFilter ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_SCINTIMUN_SINGLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Percent( activityStart, Sum( activityStart, activityFront ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_STAMICIS_CARTRIDGE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Percent( activityElution, Sum( activityElution, activityCartridge ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_STAMICIS_SINGLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Percent( activityStart, Sum( activityStart, activityFront ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_TECEOS_DOUBLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"methodOneValue": "Percent( methodOneActivityFront, Sum( methodOneActivityStart, methodOneActivityFront ) )",
		"methodTwoValue": "Percent( methodTwoActivityStart, Sum( methodTwoActivityStart, methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Difference( expectedValue, Sum( methodOneValue, methodTwoValue ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_TECEOS_DOUBLE_STRIPE_2024": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"methodOneValue": "Percent( methodOneActivityStart, Sum( methodOneActivityStart, methodOneActivityFront ) )",
		"methodTwoValue": "Percent( methodTwoActivityFront, Sum( methodTwoActivityStart, methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Difference( expectedValue, Sum( methodOneValue, methodTwoValue ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_TECHNESCAN_DSMA_SINGLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Percent( activityStart, Sum( activityStart, activityFront ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_TECHNESCAN_DTPA_DOUBLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"methodOneValue": "Percent( methodOneActivityFront, Sum( methodOneActivityStart, methodOneActivityFront ) )",
		"methodTwoValue": "Percent( methodTwoActivityStart, Sum( methodTwoActivityStart, methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Difference( expectedValue, Sum( methodOneValue, methodTwoValue ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_TECHNESCAN_HDP_DOUBLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"methodOneValue": "Percent( methodOneActivityFront, Sum( methodOneActivityStart, methodOneActivityFront ) )",
		"methodTwoValue": "Percent( methodTwoActivityStart, Sum( methodTwoActivityStart, methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Difference( expectedValue, Sum( methodOneValue, methodTwoValue ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_TECHNESCAN_MAG3_CARTRIDGE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Percent( activityElutionTwo, Sum( activityElutionOne, activityElutionTwo, activityCartridge ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_TECHNESCAN_MAG3_CARTRIDGE_V2": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Percent( activityElutionTwo, Sum( activityElutionOne, activityElutionTwo, activityCartridge ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_TECHNESCAN_SESTAMIBI_CARTRIDGE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Percent( activityElution, Sum( activityElution, activityCartridge ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_CURIUM_TECHNESCAN_SESTAMIBI_SINGLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Percent( activityStart, Sum( activityStart, activityFront ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_DOUBLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"methodOneValue": "Percent( methodOneActivityFront, Sum( methodOneActivityStart, methodOneActivityFront ) )",
		"methodTwoValue": "Percent( methodTwoActivityStart, Sum( methodTwoActivityStart, methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "sequence.lowerThreshold",
		"value": "Difference( expectedValue, Sum( methodOneValue, methodTwoValue ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_FILTER": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "sequence.lowerThreshold",
		"value": "Percent( fractionB, Sum( fractionA, fractionB, fractionC ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_RINSED_FILTER": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "sequence.lowerThreshold",
		"value": "Percent( fractionB, fractionA )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_ROTOP_B20_SINGLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Percent( activityStart, Sum( activityStart, activityFront ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_ROTOP_CARDIOTOP_DOUBLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"methodOneValue": "Percent( methodOneActivityFront, Sum( methodOneActivityStart, methodOneActivityFront ) )",
		"methodTwoValue": "Percent( methodTwoActivityStart, Sum( methodTwoActivityStart, methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Difference( expectedValue, Sum( methodOneValue, methodTwoValue ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_ROTOP_DMSA_SINGLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 98 )",
		"value": "Percent( activityStart, Sum( activityStart, activityFront ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_ROTOP_DTPA_DOUBLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"methodOneValue": "Percent( methodOneActivityFront, Sum( methodOneActivityStart, methodOneActivityFront ) )",
		"methodTwoValue": "Percent( methodTwoActivityStart, Sum( methodTwoActivityStart, methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Difference( expectedValue, Sum( methodOneValue, methodTwoValue ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_ROTOP_EHIDA_DOUBLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"methodOneValue": "Percent( methodOneActivityFront, Sum( methodOneActivityStart, methodOneActivityFront ) )",
		"methodTwoValue": "Percent( methodTwoActivityStart, Sum( methodTwoActivityStart, methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Difference( expectedValue, Sum( methodOneValue, methodTwoValue ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_ROTOP_MAG3_DOUBLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"methodOneValue": "Percent( methodOneActivityFront, Sum( methodOneActivityStart, methodOneActivityFront ) )",
		"methodTwoValue": "Percent( methodTwoActivityStart, Sum( methodTwoActivityStart, methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Difference( expectedValue, Sum( methodOneValue, methodTwoValue ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_ROTOP_MDP_DOUBLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"methodOneValue": "Percent( methodOneActivityFront, Sum( methodOneActivityStart, methodOneActivityFront ) )",
		"methodTwoValue": "Percent( methodTwoActivityStart, Sum( methodTwoActivityStart, methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Difference( expectedValue, Sum( methodOneValue, methodTwoValue ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_ROTOP_NANO_HSA_SINGLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Percent( activityStart, Sum( activityStart, activityFront ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_ROTOP_NEUROSPECT_DOUBLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"methodOneValue": "Percent( methodOneActivityFront, Sum( methodOneActivityStart, methodOneActivityFront ) )",
		"methodTwoValue": "Percent( methodTwoActivityStart, Sum( methodTwoActivityStart, methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 80 )",
		"value": "Difference( expectedValue, Sum( methodOneValue, methodTwoValue ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_ROTOP_TEKTROTYD_DOUBLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"methodOneValue": "Percent( methodOneActivityFront, Sum( methodOneActivityStart, methodOneActivityFront ) )",
		"methodTwoValue": "Percent( methodTwoActivityStart, Sum( methodTwoActivityStart, methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 90 )",
		"value": "Difference( expectedValue, Sum( methodOneValue, methodTwoValue ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_ROTOP_TETROFOSMIN_DOUBLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"methodOneValue": "Percent( methodOneActivityFront, Sum( methodOneActivityStart, methodOneActivityFront ) )",
		"methodTwoValue": "Percent( methodTwoActivityStart, Sum( methodTwoActivityStart, methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 90 )",
		"value": "Difference( expectedValue, Sum( methodOneValue, methodTwoValue ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_SINGLE_STRIPE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "sequence.lowerThreshold",
		"value": "Percent( activityStart, Sum( activityStart, activityFront ) )",
		"deviation": "Difference( value, expectedValue )"
	},
	"RP_TLC_SCANNER": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "sequence.lowerThreshold",
		"deviation": "Difference( value, expectedValue )"
	},
	"SINGLE_SELECT": {
		"recordedAt": "Fallback( recordedAt, dateTime )"
	},
	"YIELD": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, recordedAt ), recordedAt )",
		"referenceValue": "Fallback( memory.initialValue, value )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), referenceValue ), recordedHours, CS_137 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), referenceValue ), recordedHours, CS_137 )",
		"expectedValue": "Decay( referenceValue, recordedHours, CS_137 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), referenceValue ), recordedHours, CS_137 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), referenceValue ), recordedHours, CS_137 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"YIELD_BARIUM": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, recordedAt ), recordedAt )",
		"referenceValue": "Fallback( memory.initialValue, value )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), referenceValue ), recordedHours, BA_133 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), referenceValue ), recordedHours, BA_133 )",
		"expectedValue": "Decay( referenceValue, recordedHours, BA_133 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), referenceValue ), recordedHours, BA_133 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), referenceValue ), recordedHours, BA_133 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"YIELD_CAESIUM": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, recordedAt ), recordedAt )",
		"referenceValue": "Fallback( memory.initialValue, value )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), referenceValue ), recordedHours, CS_137 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), referenceValue ), recordedHours, CS_137 )",
		"expectedValue": "Decay( referenceValue, recordedHours, CS_137 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), referenceValue ), recordedHours, CS_137 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), referenceValue ), recordedHours, CS_137 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"YIELD_COBALT": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.1 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.05 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.95 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.9 ), sequence.referenceValue )",
		"deviation": "Difference( value, expectedValue )"
	},
	"YIELD_IODINE": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, recordedAt ), recordedAt )",
		"referenceValue": "Fallback( memory.initialValue, value )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), referenceValue ), recordedHours, I_129 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), referenceValue ), recordedHours, I_129 )",
		"expectedValue": "Decay( referenceValue, recordedHours, I_129 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), referenceValue ), recordedHours, I_129 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), referenceValue ), recordedHours, I_129 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"YIELD_IODINE_V2": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, recordedAt ), recordedAt )",
		"referenceValue": "Fallback( memory.initialValue, value )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), referenceValue ), recordedHours, I_129 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), referenceValue ), recordedHours, I_129 )",
		"expectedValue": "Decay( referenceValue, recordedHours, I_129 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), referenceValue ), recordedHours, I_129 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), referenceValue ), recordedHours, I_129 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"YIELD_PAYLOAD": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.1 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.05 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.95 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.9 ), sequence.referenceValue )",
		"value": "Quotient( counts, activity )",
		"deviation": "Difference( value, expectedValue )"
	},
	"YIELD_PERCENT": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.08 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerToleranceValue": "Product( Literal( 0.92 ), sequence.referenceValue )",
		"deviation": "Difference( value, expectedValue )"
	},
	"YIELD_STRONTIUM": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, recordedAt ), recordedAt )",
		"referenceValue": "Fallback( memory.initialValue, value )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), referenceValue ), recordedHours, SR_90 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), referenceValue ), recordedHours, SR_90 )",
		"expectedValue": "Decay( referenceValue, recordedHours, SR_90 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), referenceValue ), recordedHours, SR_90 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), referenceValue ), recordedHours, SR_90 )",
		"deviation": "Difference( value, expectedValue )"
	},
	"YIELD_TECHNETIUM": {
		"recordedAt": "Fallback( recordedAt, dateTime )",
		"upperToleranceValue": "Product( Literal( 1.1 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.05 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.95 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.9 ), sequence.referenceValue )",
		"deviation": "Difference( value, expectedValue )"
	}
} as const;

export const getSequenceCalculationFormula = (sequenceType: string, fieldName: string): string | null => {
	return SEQUENCE_CALCULATION_FORMULAS[sequenceType]?.[fieldName] ?? null;
};
